import "es6-promise/auto";

//css assets
import "@/assets/sass/paper-dashboard.scss";

export default {
    install(Vue) {
    }
}
